import { useCallback, useEffect } from 'react';
import { isNotEmpty } from 'rwl-shared/dist/utils/array';
import { useFilter } from 'rwl-ui';
import { setHistoryState } from '../utils/setHistoryState';

const FILTERS_URL_KEY = 'filters';

export const useFilterParam = () => {
    const {
        addAppliedFilter,
        appliedFilters,
        replaceAppliedFilters,
        clearAppliedFilters,
    } = useFilter();

    const setStateFromUrl = useCallback(() => {
        const params = new URLSearchParams(window.location.search);
        // read what filters are in the URL and update the filters with them
        const filters = params.get(FILTERS_URL_KEY);
        if (filters) {
            const filterIDs = filters.split(',');
            replaceAppliedFilters(filterIDs);
        } else {
            clearAppliedFilters();
        }
    }, []);

    // Add to applied filters on page load
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        // read what filters are in the URL and update the filters with them
        const filters = params.get(FILTERS_URL_KEY);
        if (filters) {
            const filterIDs = filters.split(',');
            filterIDs.forEach((filter) => addAppliedFilter(filter));
        }
    }, []);

    // Update the filters on back/forward
    useEffect(() => {
        window.addEventListener('popstate', setStateFromUrl);
        return () => {
            window.removeEventListener('popstate', setStateFromUrl);
        };
    }, [setStateFromUrl]);

    // when the filters change update the URL
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        if (isNotEmpty(appliedFilters)) {
            searchParams.set(FILTERS_URL_KEY, appliedFilters.join(','));
        } else {
            searchParams.delete(FILTERS_URL_KEY);
        }

        setHistoryState(searchParams, 'replace');
    }, [appliedFilters]);
};
